import request from '@/utils/request'

// 创建思维导图
export function createMindMap(data) {
  return request({
    url: '/mindmap/mindmaps/',
    method: 'post',
    data
  })
}

// 获取思维导图列表
export function getMindMapList() {
  return request({
    url: '/mindmap/mindmaps/',
    method: 'get'
  })
}

// 更新思维导图
export function updateMindMap(id, data) {
  return request({
    url: `/mindmap/mindmaps/${id}/`,
    method: 'put',
    data
  })
}

// 软删除思维导图
export function softDeleteMindMap(id) {
  return request({
    url: `/mindmap/mindmaps/${id}/soft_delete/`,
    method: 'post'
  })
}

// 获取回收站列表
export function getTrashList() {
  return request({
    url: '/mindmap/mindmaps/trash/',
    method: 'get'
  })
}

// 恢复思维导图
export function restoreMindMap(id) {
  return request({
    url: `/mindmap/mindmaps/${id}/restore/`,
    method: 'post'
  })
}

// 获取思维导图详情
export function getMindMapDetail(id) {
  return request({
    url: `/mindmap/mindmaps/${id}/`,
    method: 'get'
  })
} 